import { get, useFormContext } from "react-hook-form";

import { PasswordField } from "@components/Field";
import { FieldProps } from "@components/Field/Field/InputField";

const Password = ({
  name = "password",
  required = false,
  ...props
}: Partial<FieldProps>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <PasswordField
      block
      placeholder={L.ACTIVATE_PASSWORD_PLACEHOLDER}
      label={L.ACTIVATE_PASSWORD_LABEL}
      errorMessage={get(errors, name)?.message}
      {...props}
      {...register(name, {
        required: { value: required, message: L.REQUIRED_FIELD_VALUE },
        pattern: {
          value: /[^0-9]/g,
          message: L.PASSWORD_NON_NUMERICAL_VALIDATOR_FAIL,
        },
        minLength: { value: 8, message: L.PASSWORD_LENGTH_VALIDATOR_FAIL },
      })}
    />
  );
};

export { Password };
